import {Injectable} from '@angular/core';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {Observable} from 'rxjs';
import {
  UmpireMatchPredictorRanking,
  UmpireMatchPredictorRankingUserResult,
} from '@tisa-group/models';

@Injectable()
export class MatchPredictorRankingService implements CrudService<any> {
  prefix = '/match_predictors';

  constructor(readonly http: TisaUmpireHttpService) {}

  list(
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireMatchPredictorRanking[]>> {
    return this.http
      .get(`${this.prefix}/rankings`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  fetch(
    id: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireMatchPredictorRanking>> {
    return this.http
      .get(`${this.prefix}/rankings/${id}`, {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  create(
    match_predictors_ranking: Partial<UmpireMatchPredictorRanking>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireMatchPredictorRanking>> {
    return this.http
      .post(`${this.prefix}/rankings`, serialize({stuff: match_predictors_ranking}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  update(
    match_predictors_ranking: Partial<UmpireMatchPredictorRanking>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireMatchPredictorRanking>> {
    return this.http
      .patch(
        `${this.prefix}/rankings/${match_predictors_ranking.id}`,
        serialize({stuff: match_predictors_ranking}),
        {
          params: objectToHttpParams(params),
        },
      )
      .pipe(deserialize());
  }

  fetchUserResults(
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireMatchPredictorRankingUserResult[]>> {
    return this.http
      .get(`${this.prefix}/user_results`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`${this.prefix}/rankings/${id}`);
  }
}
